import React from "react";
import { PRIVACY_HTML } from "../UserOnboarding/MYPPrivacyPolicy";

export default class MYPPrivacyPolicy extends React.PureComponent {
  render() {
    return <div dangerouslySetInnerHTML={{ __html: PRIVACY_HTML }} />;
  }
}
